import React from "react";
import { Route } from "react-router-dom";
import { LazySuspense } from "../components/layout/AppHeader/lazySuspense";
const Login = React.lazy(() => import("../screean/login/login"));

export function login() {
  return (
    <Route
      path="/login"
      element={
        <LazySuspense>
          <Login />
        </LazySuspense>
      }
    />
  );
}
